const EVENTS_CONSTANT = {
  EVENTS_NAME: {
    WEBSITE: {
      HEADER: {
        HOME_CLICK: "homebutton_click",
        LOGIN_CLICK: "home_login_click",
        HAMBURGER_CLICK: "hamburger_click",
        ABOUT_US_CLICK: "aboutus_click",
        INTEGRATION_CLICK: "integration_click",
      },
      HOME_PAGE: {
        PAGE_VIEW: "homepage_view",
        TOP_GO_OTPLESS_CLICK: "top_gootpless_click",
        VIDEO_CLICK: "video_click",
        VIDEO_GO_OTPLESS_CLICK: "video_gootpless_click",
        REST_API_CLICK: "restapi_click",
        ANDROID_CLICK: "android_click",
        IOS_CLICK: "ios_click",
        JAVASCRIPT_CLICK: "js_click",
        FLUTTER_CLICK: "flutter_click",
        BOTTOM_GO_OTPLESS_CLICK: "bottom_gootpless_click",
      },
      NEW_LANDING: {
        INTEGRATE: "integratenow_click",
      },
      ABOUT_US: {
        PAGE_VIEW: "aboutus_view",
        TOP_GO_OTPLESS_CLICK: "aboutus_top_gootpless_click",
        PROFILE_CLICK: "profile_click",
        BOTTOM_GO_OTPLESS_CLICK: "aboutus_bottom_gootpless_click",
      },
      PRODUCT_HUNT: {
        LOGIN_WITH_WHATSAPP_CLICK: "ph_login_with_whatsapp_click",
        GO_OTPLESS_CLICK: "ph_optless_click",
      },
      FOOTER: {
        HOME_CLICK: "footer_gootpless_click",
        ABOUT_US_CLICK: "footer_aboutus_click",
        INTEGRATION_CLICK: "footer_integrations_click",
        PRIVACY_CLICK: "footer_privacy_click",
        TNC_CLICK: "footer_tnc_click",
        SOCIAL_MEDIA_CLICK: {
          INSTAGRAM: "instagram_click",
          LINKEDIN: "linkedin_click",
          FACEBOOK: "facebook_click",
          TWITTER: "twitter_click",
        },
      },
    },
    DASHBOARD: {
      SIGNUP_LOGIN: {
        PAGE_VIEW: "signuppage_view",
        GOOGLE_LOGIN_CLICK: "googlelogin_click",
        LOGIN_CLICK: "login_click",
      },
    },
    DOCS: {
      HOME_PAGE: {
        PAGE_VIEW: "docs_homepage_view",
        REST_APIS: "dosc_restapi_click",
        ANDROID: "dosc_android_click",
        IOS: "dosc_ios_click",
        JAVASCRIPT: "dosc_js_click",
        FLUTTER: "dosc_flutter_click",
      },
      ANDROID: {
        DOWNLOAD: "dosc_androidsdk_dow_click",
      },
      IOS: {
        DOWNLOAD: "dosc_iossdk_dow_click",
      },
      SIDE_MENU: {
        OTPLESS_HOME: "dosc_otplesshome_click",
        OLD_DOCS_CLICK: "docs_olddocs_click",
        WELCOME_TO_DOCS: "docs_welcome_click",
        GET_STARTED: "docs_getstarted_click",
        BACKEND_APIS: "docs_backendapis_click",
        FRONTEND_SDKS: "docs_frontendsdks_click",
      },
    },
  },
  EVENTS_PARAMS: {
    WEBSITE: {
      ABOUT_US: {
        NAME: "name",
      },
    },
  },
};

export default EVENTS_CONSTANT;
